import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'complete-task', [
  'START',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'todo',
  type: 'put',
  slug: [
    'tasks',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/complete-task-req.js